// extracted by mini-css-extract-plugin
export default {"item":"aps-patner-promotion-item_item__6pCuc"};